module.exports = __webpack_public_path__ + "img/zujin1.db7d47f4.jpg";